import { PackingMethodDto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class PackingMethodResponseModel extends GlobalResponseObject{
    data?: PackingMethodDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //ProductDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: PackingMethodDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 